<template>
  <div style="height:calc(100vh - 282px); overflow: hidden">
    <div class="shape" ref="sceneLine"></div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      option: {}
    }
  },
  computed: {
    setOption: {
      get() {
        return ''
      },
      set(val) {
        let line01 = val.shortageNew.list.reverse();
        let line02 = val.shortageProduct.list.reverse();
        let line03 = val.shortageOrder.list.reverse();
        let line04 = val.auditedAndUnsubOrder.list.reverse();
        console.log('-------------',line01);
        let xAxisData = line01.map(v=>v.time)
        // let xAxisData2 = line04.map(v=>v.time)

        let yAxisData01 = line01.map(v=>v.num)
        let yAxisData02 = line02.map(v=>v.num)
        let yAxisData03 = line03.map(v=>v.num)
        let yAxisData04 = line04.map(v=>v.num)
        let option = {
          tooltip: {
              trigger: 'axis'
          },
          legend: {
              data: ['缺货新品数', '缺货产品数', '缺货订单数', '已审未交订单数'],
              top: 5,
              icon: 'circle',
              textStyle: {
                fontSize: 14,
                padding: [2,0,0,0]
              }
          },
          color: ['rgb(239,92,100)', 'rgb(45,159,209)', 'rgb(96,199,170)', 'rgb(67,93,116)'],
          grid: {
              top: 80,
              left: '3%',
              right: '3%',
              bottom: '3%',
              containLabel: true
          },
          // dataZoom: {
          //   type: 'inside',
          //   start: 0,
          //   end: 30
          // },
          xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xAxisData
          },
          yAxis: [{
            name: '订单量',
            type: 'value',
            // max: Math.max(...[...yAxisData03,...yAxisData04,...yAxisData01,...yAxisData02]),
            // min: Math.min(...[...yAxisData03,...yAxisData04,...yAxisData01,...yAxisData02]),
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLine: { show: false },
            axisTick: { show: false },
            nameTextStyle: {
              height: 28,
              lineHeight: 28
            }
          },{
            name: '产品量',
            type: 'value',
            // max: Math.max(...[...yAxisData03,...yAxisData04,...yAxisData01,...yAxisData02]),
            // min: Math.min(...[...yAxisData03,...yAxisData04,...yAxisData01,...yAxisData02]),
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLine: { show: false },
            axisTick: { show: false },
            nameTextStyle: {
              height: 28,
              lineHeight: 28
            }
          }],
          series: [
              {
                  name: '缺货新品数',
                  type: 'line',
                  itemStyle: {
                    borderWidth: 0,
                    opacity: 0
                  },
                  areaStyle: {
                    opacity: 0.2
                  },
                  lineStyle: {
                    opacity: 0.8
                  },
                  stack: '缺货新品数',
                  data: yAxisData01,
                  yAxisIndex: 1,
                  smooth: true,
                  smoothMonotone: 'x'
              },
              {
                  name: '缺货产品数',
                  type: 'line',
                  itemStyle: {
                    borderWidth: 0,
                    opacity: 0
                  },
                  areaStyle: {
                    opacity: 0.2
                  },
                  lineStyle: {
                    opacity: 0.8
                  },
                  stack: '缺货产品数',
                  data: yAxisData02,
                  yAxisIndex: 1,
                  smooth: true,
                  smoothMonotone: 'x'
              },
              {
                  name: '缺货订单数',
                  type: 'line',
                  itemStyle: {
                    borderWidth: 0,
                    opacity: 0
                  },
                  areaStyle: {
                    opacity: 0.2
                  },
                  lineStyle: {
                    opacity: 0.8
                  },
                  stack: '缺货订单数',
                  data: yAxisData03,
                  yAxisIndex: 0,
                  smooth: true,
                  smoothMonotone: 'x'
              },
              {
                  name: '已审未交订单数',
                  type: 'line',
                  itemStyle: {
                    borderWidth: 0,
                    opacity: 0
                  },
                  areaStyle: {
                    opacity: 0.2
                  },
                  lineStyle: {
                    opacity: 0.8
                  },
                  stack: '已审未交订单数',
                  data: yAxisData04,
                  yAxisIndex: 0,
                  smooth: true,
                  smoothMonotone: 'x'
              }
          ]
        }
        option.dataZoom = [
          {
            type: 'inside',
            show: true,
            start: 0,
            end: line01.length > 10 ? (10 / line01.length) * 100 : 100,
          },
        ]
        this.option = option;
      }
    }
  },
  mounted() {
   this.setOption = this.data;
   this.$nextTick(_=>{
     this.render();
   })
  },
  methods: {
    render() {
      let chartInstance = this.$echarts.init(this.$refs['sceneLine']);
      chartInstance.setOption(this.option);
      chartInstance.dispatchAction({
        type: 'legendInverseSelect'
      });
      chartInstance.dispatchAction({
        type: 'legendSelect',
        name: '缺货订单数'
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .shape
    width 98%
    height 100%
    position relative
    z-index 999
</style>